import React, { useRef, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { SimpleButton, Flex, Textinput, Typo, SubPage } from '../../../ui';
import { CONTENT_MINI } from '../../../utils/media';
import { useSettingsActions } from '../../settings/hooks/useSettingsActions';

const ProfilePassword = () => {
  const { t } = useTranslation();
  const { updateSettings, isUpdatingSettings } = useSettingsActions();
  const passwordRef = useRef({});

  const savePassword = useCallback(async () => {
    const { currentPassword, newPassword, confirmNewPass } = passwordRef.current;
    const settingsData = {
      newPassword: newPassword.value,
      currentPassword: currentPassword.value,
      passwordConfirm: confirmNewPass.value,
    }

    await updateSettings(settingsData);
    if (currentPassword) currentPassword.value = '';
    if (newPassword) newPassword.value = '';
    if (confirmNewPass) confirmNewPass.value = '';
  }, [updateSettings])

  return (
    <SubPage size={CONTENT_MINI} align='flex-start' >
      <Typo.ContentSmallHeader $marginBottom='30px' $textAlign='left' >{t('profile.changePass')}</Typo.ContentSmallHeader>
      <Flex align='flex-start' width='80%' direction='column' >
        <Flex width='100%' gap='10'>
          <Textinput
            innerRef={el => passwordRef.current['currentPassword'] = el}
            label={t('profile.currentPassword')}
            type='password'
          />
        </Flex>
        <Flex width='100%' gap='10'>
          <Textinput
            innerRef={el => passwordRef.current['newPassword'] = el}
            label={t('profile.newPassword')}
            type='password'
          />
        </Flex>
        <Flex width='100%' gap='10'>
          <Textinput
            innerRef={el => passwordRef.current['confirmNewPass'] = el}
            label={t('profile.confirmNewPass')}
            type='password'
          />
        </Flex>
      </Flex>
      <Flex align='flex-end' gap='30' width='100%' direction='column'>
        {/* <Typo.Text $textAlign='right' >{t('auth.forgotPassword')}</Typo.Text> */}
        <SimpleButton isLoading={isUpdatingSettings} onClick={savePassword}>{t('globals.save')}</SimpleButton>
      </Flex>
    </SubPage >
  );
};

export default ProfilePassword;
